<template>
  <div>
  <h1> Login </h1>
  <label for="fname">User name</label>
  <input type="text" id="fname" name="fname" v-model="username"><br><br>
  <label for="lname">Password</label>
  <input type="password" id="lname" name="lname" v-model="password"><br><br>
  <v-btn @click="login" type="submit" color="success"> Submit </v-btn>
  <p v-if="msg"> {{msg}} </p>
  <p> Do not have a user-account yet? Register <a href="/register"> here </a></p>
  </div>
</template>

<script>
import AuthService from '../services/AuthService'
export default {
  data () {
    return {
      username: '',
      password: '',
      msg: ''
    }
  },
  methods: {
    async login () {
      try {
        const credentials = {
          username: this.username,
          password: this.password
        }
        const response = await AuthService.login(credentials)
        const token = response.data.token
        const user = response.data.user
        this.$store.dispatch('login', { token, user })
        this.msg = response.data.msg
        await new Promise((resolve, reject) => setTimeout(resolve, 2000))
        this.$router.push('/')
      } catch (error) {
        this.msg = error.response.data.msg
      }
    }
  },
  async created () {
    if (this.$store.getters.isLoggedIn) {
      this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/LoginComponent.vue